/**
 * Created by afuhr on 20.09.2016.
 */
import {makeTypedFactory} from "typed-immutable-record";

import {
  TempWithdrawal,
  TempWithdrawalCache,
  TempWithdrawalCacheRecord,
  TempWithdrawalRecord,
  TempWithdrawnStock,
  TempWithdrawnStockRecord
} from "./scans.types";


export const TempWithdrawnStockFactory = makeTypedFactory<TempWithdrawnStock, TempWithdrawnStockRecord>({
  cuid: null,
  stock: null,
  amount: 0
});

export const TempWithdrawalFactory = makeTypedFactory<TempWithdrawal, TempWithdrawalRecord>({
  cuid: null,
  administration_unit_id: null,
  withdrawal_note: null,
  withdrawal_timestamp: null,
  withdrawal_reason_id: null,
  withdrawal_reason_type: 'Einsatz',
  withdrawal_reason: null,
  consumer_type: null,
  consumer_id: null,
  consumer: null,
  personal_number: null,
  signature: null,
  authenticated_user: null,
  withdrawn_stocks: [],
  is_complete: false
});

export const TempWithdrawalCacheFactory = makeTypedFactory<TempWithdrawalCache, TempWithdrawalCacheRecord>({
  withdrawalList: [],
  activeWithdrawalCuid: null,
  is_committing: false,
  has_errored: false
});

export const INITIAL_STATE = TempWithdrawalCacheFactory();



// WEBPACK FOOTER //
// ./src/app/store-management/redux/scans.initial-state.ts